module.exports = __webpack_public_path__ + "img/level-1-stand.fffe8c6a.svg";